import { inject, Pipe, PipeTransform } from '@angular/core';
import { Currency } from '@data-access';
import { CurrencyService } from '../services/currency.service';

@Pipe({ name: 'currencyValue', standalone: true })
export class CurrencyValuePipe implements PipeTransform {
  private service = inject(CurrencyService);

  transform(currency?: Currency | null): Currency {
    return this.service.resolveCurrency(currency);
  }
}
